import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { Target, PenLine, Camera, BarChart3, type LucideIcon } from "lucide-react";
import agent1 from "@assets/Gemini_Generated_Image_jp7nmijp7nmijp7n (1)_1760809993862.png";
import agent2 from "@assets/Gemini_Generated_Image_vnvxzyvnvxzyvnvx (1)_1760810006394.png";
import agent3 from "@assets/Gemini_Generated_Image_3pwcq03pwcq03pwc_1760810036453.png";
import agent4 from "@assets/Gemini_Generated_Image_akydq1akydq1akyd_1760810088993.png";

export interface TeamMember {
  name: string;
  title: string;
  role: string;
  image: string;
  icon: LucideIcon;
}

const teamMembers: TeamMember[] = [
  {
    name: "Lina",
    title: "Die Strategin",
    role: "Strategie & Planung",
    image: agent1,
    icon: Target,
  },
  {
    name: "Max",
    title: "Der Texter",
    role: "Texte & Storytelling",
    image: agent4,
    icon: PenLine,
  },
  {
    name: "Emma",
    title: "Die Kreative",
    role: "Visuals & Design",
    image: agent3,
    icon: Camera,
  },
  {
    name: "Alex",
    title: "Der Analyst",
    role: "Daten & Timing",
    image: agent2,
    icon: BarChart3,
  },
];

export function TeamIntro() {
  return (
    <section className="py-12" data-testid="section-team-intro">
      <div className="text-center mb-8">
        <h2 className="text-2xl lg:text-3xl font-bold font-playfair mb-2">
          Dein Social Media A-Team
        </h2>
        <p className="text-muted-foreground">
          Vier Spezialisten, ein Ziel: Dein Social Media Erfolg
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {teamMembers.map((member) => {
          const IconComponent = member.icon;
          return (
            <Card
              key={member.name}
              className="text-center hover-elevate transition-all"
              data-testid={`team-member-${member.name.toLowerCase()}`}
            >
              <CardContent className="pt-6 pb-4 px-4">
                <Avatar className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-3 border-2 border-primary">
                  <AvatarImage src={member.image} alt={member.name} />
                  <AvatarFallback>{member.name[0]}</AvatarFallback>
                </Avatar>
                <div className="space-y-1">
                  <p className="text-lg font-semibold">{member.name}</p>
                  <p className="text-xs text-primary font-medium">{member.title}</p>
                  <p className="text-xs text-muted-foreground flex items-center justify-center gap-1">
                    <IconComponent className="w-3 h-3" />
                    {member.role}
                  </p>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </section>
  );
}

export { teamMembers };
